import { TransportJobsType } from '@/enum'
import JobsDisplayType from '@/enum/JobsDisplayType'
import type { TGlobalState } from '@/types/state-types'
import type { TToastNotification } from '@/types/state-types/TGlobalState'
import { DEFAULT_PAGE_LIMIT } from '@/utils/constants'

export default <TGlobalState>{
  loader: true,
  errors: null,
  abortControllers: null,
  abortControllersWithFilters: null,
  toastNotifications: [] as Array<TToastNotification>,
  refreshAttempts: 0,
  isAttemptingRefresh: false,
  renewRequestPromise: null,
  userId: null,
  accessToken: null,
  breadcrumbs: [],
  officerWorker: null,
  geofenceWorker: null,
  progressLoader: false,
  validationConfig: null,
  formAutomatedResponseFields: null,
  showBulkOperationErrors: false,
  bulkOperationErrors: null,
  bulkOperationSuccessMessage: null,
  bulkOperationFailedMessage: null,
  polygonsLoadedCount: null,
  showAuthorizedPatrols: false,
  showNotifications: false,
  showConfigFlyout: false,
  hasNewNotification: false,
  disableButtonsForRealtime: false,
  isJobDeletedResponse: false,
  hasBreadcrumbs: false,
  pageTitle: '',
  transportActiveTab: TransportJobsType.Haulage,
  customPageLimit: DEFAULT_PAGE_LIMIT,
  isExporting: false,
  haulageJobsDisplayTab: JobsDisplayType.LIST,
  digestateJobsDisplayTab: JobsDisplayType.LIST,
  spreadingJobsDisplayTab: JobsDisplayType.LIST,
}
